<template>
  <div class="pageContainer" >
    <div class="head">
      <div class="line"></div><h2>尊享试驾</h2><div class="line"></div>
      <div class="close" style="opacity: 1;position: absolute;right: 7.5%;" @click="close">
        <i class="el-icon-close" style="color: #000;"></i>
      </div>
    </div>
    <!-- <h2 v-else>尊享试驾EV5</h2> -->
    <!-- 竖屏 -->
    <div class="info info-h5">
      <el-form :inline="true" class="demo-form-inline" :model="driveForm" ref="driveForm">
        <el-row  :gutter="10" v-if="alldata">
          <el-col :span="6">
            <el-form-item label="" >
              <el-select
              v-model="driveForm.Province"
              placeholder="省份"
              @change="setProvince"
              >
                <el-option
                v-for="(item, key) in alldata.province"
                :value="item.id"
                :key="key"
                :label="item.name"
                >
              </el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item >
              <el-select
              v-model="driveForm.City"
              placeholder="城市"
              @click="setCity()"
              code-stm="event, PAGEURL, 切换城市信息mob"
              @change="cityChange"
              >
                <el-option
                v-for="(item, key) in this.cascadingCities"
                :value="item.id"
                :key="key"
                :label="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="">
              <el-select
              v-model="driveForm.DealerCode"
              placeholder="经销商"
              @change="dealerChange"
              >
                <el-option
                v-for="(item, key) in this.cascadingDealers"
                :key="key"
                :value="item.code"
                :label="item.name"
                :disabled="(item.latitude==''&& item.longitude=='')?true:false"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="24">
            <el-form-item label="">
              <el-select
                v-model="driveForm.DealerCode"
                placeholder="请选择经销商"
                @change="dealerChange"
              >
                <el-option
                  v-for="(item, key) in this.cascadingDealers"
                  :key="key"
                  :value="item.code"
                  :label="item.name"
                  :disabled="(item.latitude==''&& item.longitude=='')?true:false"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <!-- <el-row :gutter="20" v-if="carAlldata">
          <el-col :span="24" class="selectcar">
            <el-form-item label="*车型">
              <el-select
                v-model="driveForm.CarSeriesCMSID"
                placeholder="请选择车型"
                disabled
                aria-disabled="true"
                @change="setCarSeries"
              >
                <el-option
                  v-for="item in carAlldata.series"
                  :key="item.name"
                  :value="item.cmsid"
                  :label="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-form-item label="" style="margin-right: 10px;">
            <el-input
              v-model="driveForm.Name"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model="driveForm.Phone"
              placeholder="请输入手机号"
              maxlength="11"
              oninput="if(value.length > 11) value=value.slice(0, 11)"
            ></el-input>
          </el-form-item>
        </el-row>
        <!-- <el-row>
          <el-form-item label="*短信验证码">
            <el-col :span="12">
              <el-input
                placeholder="请输入验证码"
                class="input"
                v-model="driveForm.Code"
                maxlength="6"
                oninput="if(value.length > 6) value=value.slice(0, 6)"
              />
            </el-col>
            <el-col :span="12">
              <el-button
                class="button"
                @click="countDown()"
                code-stm="event, PAGEURL, 获取验证码mob"
                :class="{ disabled: !this.countDownCanClick }"
                >{{ countDownContent }}</el-button
              >
            </el-col>
          </el-form-item>
        </el-row> -->
        <el-row class="my-checkbox">
          <el-checkbox
            v-model="driveForm.checked"
            className="agreement-checkbox"
            @click.stop
          >
            <span>
              我已阅读并同意<span style="display: inline;color: #70a1ff;" @click.stop.prevent="toTerms">《隐私协议》</span>，且同意起亚经销商与我联系。
            </span>
          </el-checkbox>
        </el-row>
        <span class="submit-button"  @click="submitInformation"
              code-stm="event, PAGEURL, 提交预约试驾表单信息mob">提交信息</span>
      </el-form>
    </div>
  </div>

</template>

<script>
import {  getUrlKey,isPortraitFun,isAndroid } from "@/utils/utils.js";
import { apiUrl, pcdUrl, CSMUrl } from "@/config/base";
// import myBMap from "@/utils/myBMap";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      isAndroid:isAndroid(),
      alldata: null,
      carAlldata: null,
      closeIcon: require("@/assets/images/onepage/close.png"),

      carModelSeries: [],
      cascadingCities: [],
      cascadingDealers: [],
      // canCheck: false,
      totalTime: 60,
      countDownContent: "获取验证码",
      countDownCanClick: true,
      driveForm: {
        //试驾
        Phone: "",
        Name: "",
        Code: "",
        Province: "",
        City: "",
        CarSeriesCMSID: "436",
        CarSeriesName: "EV5",
        CarModelCMSID: "1401",
        CarModelName: "530 Light",
        DealerName: "",
        DealerCode: "",
        checked: false,
      },
      params: null, // 留资参数
    };
  },
  props: {
    clientPosition: {
      type: Object,
      default: null
    }
  },

  created: function () {
    if (!this.alldata) {
      console.log("try to fetch alldata from created");
      this.$axios.get(pcdUrl).then((res) => {
        console.log("fetched alldata from created", res.data);

        this.alldata = res.data;
        this.initData();
      });
    }
    window.addEventListener("resize", this.setResize);

  },
  mounted() {
    this.$nextTick(()=>{
      // console.log("获取位置");
      // this.getLocation()
    })
  },
  watch:{
    // 地址定位
    clientPosition(val) {
      if(val) {
        this.driveForm.Province = this.alldata.province.filter(item => item.name == val.province)[0].id
        this.setCity();
        this.driveForm.City = this.alldata.city[this.driveForm.Province].filter(item => item.name == val.city)[0].id
        this.cityChange(this.driveForm.City)
      }
    },
  },
  methods: {
    toTerms(){
      this.$router.push({
        path: '/terms'
      })
    },
    handleCheckboxChange(){
      console.log("handleCheckboxChange");
      this.driveForm.checked = !this.driveForm.checked
    },
    close(){
      this.$emit('close')
    },
    initData() {
      let that = this;
      this.$axios.get(CSMUrl).then((res) => {
        console.log("车型车款数据", res.data);
        that.carAlldata = res.data;
      });
    },
    autoSet(a){
      // let rs = this.clientPosition
      let rs = a
      let theProv = this.alldata.province.find(res=>res.name == rs.addressComponents.province)
      // console.log(theProv);
      this.driveForm.Province = theProv.id
      this.setProvince()
      let theCity = this.cascadingCities.find(res=>res.name == rs.addressComponents.city)
      this.driveForm.City = theCity.id
      this.setCity()
    },
    setResize() {
      // console.log(13123, this.isPortrait);
      this.isPortrait = isPortraitFun();
    },
    setProvince() {
      this.driveForm.City = "";
      this.setCity();
    },
    setCity() {
      // this.cascadingCities = this.alldata.city[this.driveForm.Province];
      this.cascadingCities = [];
      this.alldata.city[this.driveForm.Province].forEach((cityIter) => {
        //过滤city
        //TODO:includes "8" 是1S店  7是城市展厅
        if (
          this.alldata.cityRelType[cityIter.id].includes("1") ||
          this.alldata.cityRelType[cityIter.id].includes("4") ||
          this.alldata.cityRelType[cityIter.id].includes("7")
          // || this.alldata.cityRelType[cityIter.id].includes("8")
        ) {
          this.cascadingCities.push(cityIter);
        }
      });
      this.driveForm.City = this.driveForm.City || this.cascadingCities[0].id;
      this.cityChange(this.driveForm.City);
    },

    setCarSeries() {
      this.driveForm.CarModelCMSID = "436";
      console.log(
        "this.driveForm.CarSeriesCMSID",
        this.driveForm.CarSeriesCMSID
      );
      if(this.driveForm.CarSeriesCMSID){
        this.driveForm.CarModelCMSID = this.carAlldata.model[this.driveForm.CarSeriesCMSID].at(-1).cmsid;
        this.driveForm.CarModelName = this.carAlldata.model[this.driveForm.CarSeriesCMSID].at(-1).name;
      }
      console.log('this.driveForm.CarModelName',this.driveForm.CarModelName);
    },
    cityChange(cityId) {
      //改变经销商数据/起点
      let temp = this.alldata.dealer[cityId];
      this.cascadingDealers = [];
      temp.forEach((origin) => {
        //TODO:origin.type == "8" 是1S店  7是城市展厅
        if (origin.type == "1" || origin.type == "4" || origin.type == "7") {
          this.cascadingDealers.push(origin);
        }
      });

      // 计算距离
      const distance = (this.clientPosition.lat *  this.clientPosition.lat + this.clientPosition.lng * this.clientPosition.lng)
      const distanceArr = this.cascadingDealers.map(item => {
        const countDC = Math.abs((item.latitude * item.latitude + item.longitude * item.longitude) - distance)
        return countDC
      })

      let idx = this.findMinIndex(distanceArr)

      this.driveForm.DealerCode = this.cascadingDealers[idx].code;
      this.driveForm.DealerName = this.cascadingDealers[idx].name;
    },
    findMinIndex(arr) {
      if (!Array.isArray(arr) || arr.length === 0) {
        return 0;
      }
      let minIndex = 0;
      for (let i = 1; i < arr.length; i++) {
        if (arr[i] < arr[minIndex]) {
          minIndex = i;
        }
      }
      return minIndex;
    },
    dealerChange(dealerCode) {
      let dealer = this.cascadingDealers.find((value) => {
        return value.code === dealerCode;
      });
      this.driveForm.DealerCode =
        dealer == null ? this.cascadingDealers[0].code : dealer.code;
      this.driveForm.DealerName =
        dealer == null ? this.cascadingDealers[0].name : dealer.name;
    },
    countDown() {
      if (!this.driveForm.Phone) {
        this.$message.error("请填写正确的手机号");
        return;
      }
      if (!this.countDownCanClick) return; //改动的是这两行代码
      this.countDownCanClick = false;
      this.countDownContent = this.totalTime + "s后重试";
      var clock = window.setInterval(() => {
        this.totalTime--;
        this.countDownContent = this.totalTime + "s后重试";
        if (this.totalTime < 0) {
          window.clearInterval(clock);
          this.countDownContent = "重新发送";
          this.totalTime = 60;
          this.countDownCanClick = true; //这里重新开启
        }
      }, 1000);
      //发送验证码
      let getCodeData = {
        phoneNumbers: this.driveForm.Phone,
      };
      this.$axios
        .post(`${apiUrl}sendMsg/cityTour/sendVerificationCode`, getCodeData)
        .then((res) => {
          console.log("ressssssss", res);
          if (res.data.success) {
            this.$message.info("验证码发送成功，请注意查收");
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    submitInformation(){
      console.log("this su");
       if (
        !this.driveForm.Name ||
        !this.driveForm.Phone ||
        !this.driveForm.CarSeriesCMSID
      ) {
        this.$message.error("请完善信息后再次提交");
        return;
      }
      // 验证手机号
      if (!/^1[3456789]\d{9}$/.test(this.driveForm.Phone)) {
        this.$message.error("请填写正确的手机号");
        return;
      }
      //获取车型名字
      console.log(typeof(this.carAlldata))
      let CarSeriesName = this.carAlldata.series.find((item, index) => {
        return item.cmsid === this.driveForm.CarSeriesCMSID;
      });
      //获取默认经销商名字和编码
      if (!this.driveForm.DealerCode || !this.driveForm.DealerName) {
        this.driveForm.DealerCode = this.cascadingDealers[0].code;
        this.driveForm.DealerName = this.cascadingDealers[0].name;
      }
      //将省市转化成字符串
      let provinceStr = this.alldata.province.find(
        (item) => item.id === this.driveForm.Province
      );
      let cityStr = this.alldata.city[this.driveForm.Province].find(
        (item) => item.id === this.driveForm.City
      );
      provinceStr = provinceStr.name;
      cityStr = cityStr.name;

      if (!this.driveForm.checked) {
        this.$message.error("请先同意起亚及合作商就购买新车事宜与您联系您同意提供电话号码");
        return;
      }
      let subFormDrive = {
        //媒体来源、活动来源、媒体渠道ID没写
        carModelCmsid: this.driveForm.CarModelCMSID,
        carModelName: this.driveForm.CarModelName,
        carSeriesCmsid: this.driveForm.CarSeriesCMSID,
        carSeriesName: 'EV5',
        cityName: cityStr,
        dealerCode: this.driveForm.DealerCode,
        dealerName: this.driveForm.DealerName,
        provinceName: provinceStr,
        userName: this.driveForm.Name,
        userPhone: this.driveForm.Phone,
        verificationCode: this.driveForm.Code,
        smartCode: getUrlKey("utm_source") || "官网", //媒体来源
        activity: getUrlKey("utm_activity") || "EV5广告页", //活动名称
        extraSix: getUrlKey("utm_soid") || "22",
      };
      // let subFormDrive = {
      //   //媒体来源、活动来源、媒体渠道ID没写
      //   CarSeriesCMSID: this.driveForm.CarModelCMSID,
      //   CarModelName: this.driveForm.CarModelName,
      //   CarModelCMSID: this.driveForm.CarSeriesCMSID,
      //   CarSeriesName: CarSeriesName.name,
      //   City: cityStr,
      //   DealerCode: this.driveForm.DealerCode,
      //   DealerName: this.driveForm.DealerName,
      //   Province: provinceStr,
      //   Name: this.driveForm.Name,
      //   Phone: this.driveForm.Phone,
      //   Code: this.driveForm.Code,
      //   SmartCode: getUrlKey("utm_source") || "官网", //媒体来源
      //   Activity: getUrlKey("utm_activity") || "EV5长续航上市", //活动名称
      //   ExtraSix: getUrlKey("utm_soid") || "76",
      // };
      //预约试驾接口
      this.$axios.post(`${apiUrl}clue/australiaPage`,subFormDrive).then((res) => {
      // this.$axios.post(`${apiUrl}Clue/TestDriveSaveClue`,subFormDrive).then((res) => {
        console.log(99999998888,res);
        if (res.data.success) {
          this.$message.success("预约试驾成功");
          console.log(subFormDrive);
          setTimeout(() => {
            this.driveForm.CarModelCMSID="1401";
            this.driveForm.CarSeriesCMSID="436";
            this.driveForm.CarModelName="530 Light"
            this.driveForm.DealerCode="";
            this.driveForm.DealerName="";
            this.driveForm.Name="";
            this.driveForm.Phone="";
            this.driveForm.Code="";
            this.driveForm.City="";
            this.driveForm.Province="";
            this.driveForm.checked = false;
          }, 1000);
        } else {
          this.$message.error("预约试驾失败:" + res.data.message);
          console.log(subFormDrive);
          console.log(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pageContainer {
  width: 100%;
  // height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #FFF;
  border-radius: 10px 10px 0 0;
  .head{
    display: flex;
    align-items: center;
    margin: 20px 0;

  }
  .line{
    width: 30px;
    height: 2px;
    background: #05141F;
    // margin-bottom: 20px;
  }

  // @media screen and (orientation: portrait) {
    justify-content: flex-start;
    background: #FFF;
    h1 {
      font-size: 30px;
      padding: 8% 0 0;
    }
    h2 {
      // padding: 4.4rem 0 0;
      line-height: 3.6rem;
      font-size: 24px;
      text-align: center;
      color: #05141F;
      font-weight: bold;
      font-family: 'FZLanTingHeiS-B-GB-Regular';
      padding: 0 10px ;
      &::before {
        display: none;
      }
      &::after {
        display: none;
      }
    }
    ::v-deep .el-input__inner {
      height: 42px;
      line-height: 42px;
      font-size: 12px;
    }
    .el-button {
      height: 42px;
      background: #fff;
      color: #000;
    }
    .submit-button {
      font-size: 14px;
      padding: 10px 0;
      line-height: 1.5;
      background: #05141F;
      color: #FFFFFF;
    }
    .el-row {
      box-sizing: border-box;
      margin-top: 3%;
      display: flex;
      align-items: flex-end;
    }
    ::v-deep .el-form-item__content .inline-txt {
      position: absolute;
      line-height: 42px;
      padding: 0 10px;
      color: #05141F99;
    }
  // }
}
.submit-button {
  width: 100%;
  display: block;
  text-align: center;
  background-color: #05141F;
  padding: 2% 0;
  color: #FFFFFF;
  font-size: 20px;
  margin-top: 2%;
  cursor: pointer;
}
.el-button {
  width: 100%;
  background: #000000;
  border-radius: 0px;
  height: 50px;
  color: #fff;
  border: none;
}
::v-deep .el-checkbox__label span {
  display: block;
  color: #a7a7a7;
  margin-top: 15px;
  font-size: 12px;
}
::v-deep .el-checkbox__inner {
  background: transparent;
  border: 1px solid rgba($color: #000000, $alpha: 0.3);
}
::v-deep .el-form-item {
  margin: 0;
  width: 100%;
}

::v-deep .el-form-item__content {
  width: 100%;
  .inline-txt {
    position: absolute;
    line-height: 50px;
    padding: 0 10px;
    color: #3d3d3d;
  }
}

::v-deep .el-select {
  width: 100%;
  .el-input__inner {
    padding: 0 10px;
    background: transparent;
  }
}
::v-deep .el-input__inner {
  border-radius: 0px;
  height: 50px;
  line-height: 50px;
  background: transparent;
  border: 1px solid rgba($color: #000000, $alpha: 0.3);
  color: #3d3d3d;
}
::v-deep .el-form--inline .el-form-item__label {
  display: block;
  text-align: left;
  color: #05141F;
  font-size: 1.04vw;
}
::v-deep .el-checkbox__input{
  vertical-align: top;
}
::v-deep .el-checkbox__label span {
  display: block;
  margin-top: 0px;
  white-space: pre-wrap;
}
.agreement-checkbox {
  display: flex;
  align-items: center;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #05141F;
    border-color: #05141F;
}

.info-h5 {
  width: 85%!important;
  // margin-top: 2.5rem!important;
  margin-bottom: 40px;
  ::v-deep .el-form--inline .el-form-item__label {
    font-size: 14px;
    line-height: 25px;
    color: #05141F;
  }
  .el-checkbox {
    display: flex;
    align-items: center;
  }
  ::v-deep .el-checkbox__label {
    margin-left: 0px;
    span {
      font-size: 10px;
    }
  }
  ::v-deep .el-input__inner {
    border: 1px solid #05141F66;
    color: #05141F;
  }
  ::v-deep .el-checkbox__inner {
      border: 1px solid #05141F66!important;
  }
}
</style>
